import Card, {
  CardActionButtons,
  CardActionIcons,
  CardActions,
  CardPrimaryContent,
  CardMedia,
} from '@material/react-card';
import './Card.scss';

/**
 * Card MCWR Component
 *
 * @version ./package.json
 */
export default Card;

export {
  CardActionButtons,
  CardActionIcons,
  CardActions,
  CardPrimaryContent,
  CardMedia,
};
